<template>
  <div slot="input">
    <v-row>
      <v-flex>
        <div class="date-as-calendar position-pixels" @click="handleClick" style="cursor: pointer">
          <span class="weekday">{{formatWeekday(values1)}}</span>
          <span class="day">{{formatDay(values1)}}</span>
          <span class="month">{{formatMonth(values1)}}</span>
          <span class="year">{{formatYear(values1)}}</span>
        </div>
        <div :class="{ noShow: isClose }">
          <CalendarDialog language="en" refName="calendarDialog" apply-button-label="apply" :show-helper-buttons="true" :helper-buttons="helperButtons" :switch-button-initial="true" :dateInput="dateInput" :time-input="calendarTimeInput" @on-apply="dateApplied" @select-date="selectD" />
        </div>
      </v-flex>
      <v-flex>
        <div v-if="this.$vuetify.theme.dark == true">
          <span style="font-size: 1.3vw; color: white; font-family:'Share Tech Mono', monospace; padding-left: 8px">{{formatTime(values1)}}
            <p class="text-center" style="font-size: 1vw; color: white; font-family:'Share Tech Mono', monospace; padding-left: 8px">{{formatTAmPm(values1)}}
            </p>
          </span>
        </div>
        <div v-else>
          <span style="font-size: 1.3vw; color: black; font-family:'Share Tech Mono', monospace; padding-left: 8px">{{formatTime(values1)}}
            <p class="text-center" style="font-size: 1vw; color: black; font-family:'Share Tech Mono', monospace; padding-left: 8px">{{formatTAmPm(values1)}}
            </p>
          </span>
        </div>
      </v-flex>
      <v-flex style="padding-left:6px; padding-top:15px">
        <v-icon large color="blue-grey">
          mdi-arrow-right-bold
        </v-icon>
      </v-flex>
      <v-flex>
        <div class="date-as-calendar position-pixels" @click="handleClick" style="cursor: pointer">
          <span class="weekday">{{formatWeekday(values2)}}</span>
          <span class="day">{{formatDay(values2)}}</span>
          <span class="month">{{formatMonth(values2)}}</span>
          <span class="year">{{formatYear(values2)}}</span>
        </div>
      </v-flex>
      <v-flex>
        <div v-if="this.$vuetify.theme.dark == true">
          <span style="font-size: 1.3vw; color: white; font-family:'Share Tech Mono', monospace; padding-left: 8px">{{formatTime(values2)}}
            <p class="text-center" style="font-size: 1vw; color: white; font-family:'Share Tech Mono', monospace; padding-left: 8px">{{formatTAmPm(values2)}}
            </p>
          </span>
        </div>
        <div v-else>
          <span style="font-size: 1.3vw; color: black; font-family:'Share Tech Mono', monospace; padding-left: 8px">{{formatTime(values2)}}
            <p class="text-center" style="font-size: 1vw; color: black; font-family:'Share Tech Mono', monospace; padding-left: 8px">{{formatTAmPm(values2)}}
            </p>
          </span>
        </div>
      </v-flex>
    </v-row>
  </div>
</template>

<script>
import moment from 'moment';
import { CalendarDialog }  from 'vue-time-date-range-picker/dist/vdprDatePicker';

export default {
  components: {
    CalendarDialog
  },
    props: {
    values1: [Object, String, Date],
    values2: [Object, String, Date],
    updateData: Function,
    isClose: [Boolean, Function],
    dateApplied: Function,
    selectD: Function,
  },
    data: () => ({
    dateInput: {
        inputClass: ["dt_picker"],
        format: "DD/MM/YYYY",
      },
      calendarTimeInput: {
        step: 30,
      },
      helperButtons: [
        {
          name: "Last 1 Hour",
          from: moment().subtract(1, "hour"),
          to: moment(),
        },
        {
          name: "Last 3 Hour",
          from: moment().subtract(3, "hour"),
          to: moment()
        },
        {
          name: "Last 12 Hour",
          from: moment().subtract(12, "hour"),
          to: moment()
        },
        {
          name: "Today",
          from: moment().startOf("day"),
          to: moment().endOf("day")
        },
        {
          name: "This Week",
          from: moment().clone().startOf("week"),
          to: moment().clone().endOf("week")
        },
        {
          name: "Last Week",
          from: moment().subtract(1, 'weeks').startOf('week'),
          to: moment().subtract(1, "week").endOf("week")
        },
        {
          name: "This Month",
          from: moment().clone().startOf("month"),
          to: moment().clone().endOf("month"),
        },
        {
          name: "Last Month",
          from: moment().subtract(1, "month").startOf("month"),
          to: moment().subtract(1, "month").endOf("month")
        },
      ],
}),
methods: {
   handleClick() {
        this.isClose = !this.isClose;
      },
      formatTime(value) {
      return moment(value).format("h:mm")
      },
      formatTAmPm(value) {
      return moment(value).format("A")
      },
      formatDay(value) {
      return moment(value).format("DD")
      },
      formatYear(value) {
      return moment(value).format("YYYY")
      },
      formatMonth(value) {
      return moment(value).format("MMMM")
      },
      formatWeekday(value) {
      return moment(value).format("dddd")
    },
     updateTime() {
      const time = () => {
          setInterval(() => {
              this.helperButtons.forEach((btn, i) => {
                  if(i === 0) {
                      btn.from =  moment().subtract(1, "hour").toDate()
                      btn.to =  moment()
                  }

                  if(i === 1) {
                      btn.from =  moment().subtract(3, "hour").toDate()
                      btn.to =  moment()
                  }

                  if(i === 2) {
                      btn.from =  moment().subtract(12, "hour").toDate()
                      btn.to =  moment()
                  }
              })
          }, 1000)
      } 
        time();
      }    
},
  beforeMount() {
    this.updateTime()
  }
}
</script>

<style scoped>
.pick {
  z-index: 999;
  color: black;
  cursor: pointer;
}
@import url(https://fonts.googleapis.com/css?family=Source+Code+Pro|Oswald);

/****************************************/
/* Styling rules, such as font and colors */
.date-as-calendar {
  font-variant: normal;
  font-style: normal;
  font-weight: normal;
  font-family: "Helvetica", "Arial", sans-serif;

  /* It seems vertical-align: baseline does not work correctly with display: inline-flex. */
  vertical-align: top;

  /* margin: 1ex; */

  color: black;
  background: white;
  background: linear-gradient(to bottom right, #fff 0%, #eee 100%);

  border: 1px solid #888;
  border-radius: 3px;
  overflow: hidden;

  box-shadow: 2px 2px 2px -2px black;
}
.date-as-calendar .weekday,
.date-as-calendar .day,
.date-as-calendar .month,
.date-as-calendar .year {
  text-align: center;
  line-height: 1;
}
.date-as-calendar .month {
  font-family: "Oswald", sans-serif;
  text-transform: uppercase;
  background: #b11;
  background: linear-gradient(to bottom right, #d66 0%, #a00 100%);
  color: white;
}
/****************************************/
/* Layout rules using position: absolute and pixels. */
.position-pixels.date-as-calendar {
  display: inline-block;
  position: relative;
  width: 90px;
  height: 75px;
}
.position-pixels.date-as-calendar .weekday,
.position-pixels.date-as-calendar .day,
.position-pixels.date-as-calendar .month,
.position-pixels.date-as-calendar .year {
  display: block;
  position: absolute;
  left: 0;
  right: 0;
  width: 100%;
  height: 1.4em;
}
.position-pixels.date-as-calendar .month {
  top: 0px;
  font-size: 0.7vw;
  padding: 2px 0;
}
.position-pixels.date-as-calendar .weekday {
  top: 21px;
  font-size: 0.6vw;
}
.position-pixels.date-as-calendar .day {
  top: 34px;
  font-size: 1.2vw;
}
.position-pixels.date-as-calendar .year {
  top: 58px;
  font-size: 0.7vw;
}

.noShow {
  display: none;
}

.vdpr-datepicker__calendar-dialog >>> .vdpr-datepicker__calendar,
.vdpr-datepicker__calendar-dialog >>> .vdpr-datepicker__calendar-input-wrapper {
  color: black;
}
</style>